import { useMemo } from 'react';

// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './Toast.module.css';

// Components
import Picto from '../../atoms/Picto/Picto';

/**
 * Toast component
 * @param {ToastProps} props - The props of the component
 * @returns {JSX.Element} The Toast component
 */
function Toast({
  type = 'info', hasIcon = true, hasCross = false, children,
}) {
  /**
   * import available icons
   * @returns {import('../../atoms/Picto/Picto').availablePictos} The icon to display
   */
  const icon = useMemo(() => {
    switch (type) {
      case 'success':
        return 'add';
      case 'alert':
        return 'close-md';
      case 'info':
      default:
        return 'message-question';
    }
  }, [hasIcon]);

  return (
    <div className={cn([styles.container, styles[type]])}>
      <div className={styles.content}>
        {hasIcon ? <Picto icon={icon} className={styles.icon} /> : null}
        {children}
      </div>
      {hasCross ? <Picto icon="close-md" className={styles.close} /> : null}
    </div>
  );
}

export default Toast;
